import { e as error, j as json } from "../../../../chunks/index2.js";
import { g as generateLicenseAndNotifyUser } from "../../../../chunks/license.js";
import { s as stripe } from "../../../../chunks/stripe.js";
import { c as STRIPE_WEBHOOK_SECRET } from "../../../../chunks/private.js";
const POST = async ({ request }) => {
  const sig = request.headers.get("stripe-signature");
  let event;
  try {
    event = stripe.webhooks.constructEvent(
      Buffer.from(await request.arrayBuffer()),
      sig,
      STRIPE_WEBHOOK_SECRET
    );
  } catch (err) {
    console.error(err);
    return error(400, { message: `Webhook Error: ${err.message}` });
  }
  const type = event.type;
  if (type === "payment_intent.succeeded") {
    await generateLicenseAndNotifyUser(
      event.data.object,
      "Thank you for purchasing a pro license."
    );
  }
  return json({
    received: true
  });
};
export {
  POST
};
